import { primaryMenuString } from "constants/constantStrings";
import { SYSTEMS_PAGES } from "constants/pages.constant";

import AlarmsIcon from "assets/SvgIcon/SideBar/AlarmsIcon";
import AnalyticsIcon from "assets/SvgIcon/SideBar/AnalyticsIcon";
import BaselineIcon from "assets/SvgIcon/SideBar/BaselineIcon";
import ChartIcon from "assets/SvgIcon/SideBar/ChartIcon";
import DashboardIcon from "assets/SvgIcon/SideBar/Dashboard";
import ReportsIcon from "assets/SvgIcon/SideBar/ReportsIcon";
import SmartInsightsIcon from "assets/SvgIcon/SideBar/SmartInsightIcon";
import TagsIcon from "assets/SvgIcon/SideBar/TagsIcon";

export const getSideNavItems = (admin, tier1, tier2, sysId) => [
  {
    relativePath: SYSTEMS_PAGES.DASHBOARDS,
    name: primaryMenuString.dashboard,
    icon: DashboardIcon,
    visible: true,
    isActive: false
  },
  {
    relativePath: SYSTEMS_PAGES.CHARTS,
    name: primaryMenuString.charts,
    icon: ChartIcon,
    visible: true,
    isActive: false
  },
  {
    relativePath: SYSTEMS_PAGES.REPORTS,
    name: primaryMenuString.reports,
    icon: ReportsIcon,
    visible: true,
    isActive: false
  },
  {
    relativePath: SYSTEMS_PAGES.ANALYTICS,
    name: primaryMenuString.analytics,
    icon: AnalyticsIcon,
    visible: admin || tier2,
    isActive: false
  },
  {
    relativePath: SYSTEMS_PAGES.INSIGHTS,
    name: primaryMenuString.smartInsights,
    icon: SmartInsightsIcon,
    visible: admin || tier2,
    isActive: false
  },
  {
    relativePath: SYSTEMS_PAGES.ALARMS,
    name: primaryMenuString.alarms,
    icon: AlarmsIcon,
    visible: true,
    isActive: false
  },
  {
    relativePath: SYSTEMS_PAGES.TAGS,
    name: primaryMenuString.tags,
    icon: TagsIcon,
    visible: true,
    isActive: false
  },
  {
    relativePath: SYSTEMS_PAGES.BASELINES,
    name: primaryMenuString.baseline,
    icon: BaselineIcon,
    visible: true,
    isActive: false
  }
];
